import React from "react"
import Dropdown from "../../../../Dropdown/Dropdown"
import { options } from "./options"
import { setCompanyIndustryType } from "../../useReducer/actionCreators"
import useOption from "./useOption"

const IndustryDropdown = ({ externalDispatch, selectedType }) => {
  const [option, setOption] = useOption(selectedType)
  return (
    <Dropdown
      label="Industry"
      id="industry_type_dropdown"
      options={options}
      value={option}
      onChange={(option) => {
        setOption(option)
        externalDispatch(setCompanyIndustryType(option.id))
      }}
    />
  )
}
export default IndustryDropdown
